__turbopack_context__.v({
  "__close-button": "footer-ad-contents-module-scss-module__mhvESW____close-button",
  "__container": "footer-ad-contents-module-scss-module__mhvESW____container",
  "footer-ad-contents": "footer-ad-contents-module-scss-module__mhvESW__footer-ad-contents",
});
